/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_ProgressInputs */

const he_common_progress = /** @type {(inputs: Common_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התקדמות`)
};

const en_common_progress = /** @type {(inputs: Common_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progress`)
};

/**
* | output |
* | --- |
* | "Progress" |
*
* @param {Common_ProgressInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const common_progress = /** @type {((inputs?: Common_ProgressInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_ProgressInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_progress(inputs)
	return en_common_progress(inputs)
});